import { render, staticRenderFns } from "./vpd-resetpass-panel.vue?vue&type=template&id=0bb9d3fa&"
import script from "./vpd-resetpass-panel.vue?vue&type=script&lang=js&"
export * from "./vpd-resetpass-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports